import { useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  FormControl,
  FormErrorMessage,
} from "@chakra-ui/react";
import { Checkbox } from "barte-design-system";

interface PaymenthsMethodsProps {
  register?: any;
  data?: any;
  errors?: any;
  noTitle?: boolean;
}

const PaymenthsMethods = ({
  register,
  data,
  errors,
  noTitle = false,
}: PaymenthsMethodsProps) => {
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    if (data) {
      setInitialData(data);
    }
  }, [data]);

  return (
    <>
      {initialData && (
        <Box
          w="100%"
          key={`${initialData?.idCheckout}-${initialData?.enableCreditCard}-${initialData?.enablePixPayment}-${initialData?.enableBankSlip}`}
        >
          {!noTitle && (
            <Text
              mb="2"
              color="var(--content-primary)"
              fontSize="14px"
              fontWeight="500"
            >
              Métodos de Pagamento do Plano
            </Text>
          )}
          <FormControl isInvalid={errors}>
            <Flex
              w="100%"
              flexDirection="column"
              align="flex-start"
              gap="3"
            >
              <Checkbox
                name="enableCreditCard"
                size="sm"
                {...register("enableCreditCard")}
                defaultChecked={initialData?.enableCreditCard}
                label="Cartão de crédito"
              />

              <Checkbox
                name="enablePixPayment"
                size="sm"
                {...register("enablePixPayment")}
                defaultChecked={initialData?.enablePixPayment}
                label="PIX"
              />

              <Checkbox
                name="enableBankSlip"
                size="sm"
                {...register("enableBankSlip")}
                defaultChecked={initialData?.enableBankSlip}
                label="Boleto"
              />

              {errors && <FormErrorMessage>{errors?.message}</FormErrorMessage>}
            </Flex>
          </FormControl>
        </Box>
      )}
    </>
  );
};

export { PaymenthsMethods };
